<template>
<b-row class="email no-gutters">

    <b-col class="tool-border" cols="12">
      <modalImpDisc v-if="userData.isEmailSent "></modalImpDisc>
        <tedtfHeader :image="'email'" :screenTitle="'SHARE A LINK TO THIS TOOL VIA EMAIL'"></tedtfHeader>
        <b-col class="page-background-gradient reduce-padding" cols="12">
            <b-row class="page-content no-gutters">
                <div class="body-sec">
                       <div>
              <div class="envelop-img email-img"></div>
              <div class="main-text">Complete the fields below to email a link and brief description of the TED Triggers and Flares Tool to others who may find it interesting.</div>
               <b-col cols="12" class=" reduce-padding">
             
                <div class="email-sec cmn-sec">
                  <div class="txt-bold">To:</div>
                  <div class="input-feilds ">
                    <b-row class="no-gutters" :class="{'haserror': submitted && (!$v.userData.email.required || !$v.userData.email.email ||
                     !$v.userData.email.maxLength)}">
                      <b-col lg="6" class="reduce-padding">
                        <div class=" field-size">
                          <input class="common-field form-control" :maxLength="100" type="email" id="emailiD" name="emailiD" v-model="userData.email" :placeholder="placeholderEmail">
                        </div>
                      </b-col>

                      <b-col v-if="submitted && (!$v.userData.email.required || !$v.userData.email.email ||
                     !$v.userData.email.maxLength)" lg="6" class="reduce-padding">
                        <div class="error">Enter valid email address.</div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
            </b-col>
            <b-col cols="12" class=" reduce-padding">
              <div class="bttn-sec ">
                <button @click.prevent="handleSubmit($event, userData.email, '')" class="submit-bttn" @click="submit()">
                 SUBMIT
                </button>
              </div>
            </b-col>
            <b-col cols="12" class=" reduce-padding">
              <div class="italic-text">Click “SUBMIT” to continue or “BACK” to return to the Summary and Next Steps.</div>
            </b-col>
            </div>
                </div>
            </b-row>
        </b-col>
        
                <tedftNavigation v-bind:navButtons="['back', 'showMidCol', 'showspecialist']" :currentScreen="10" :isSymptom="true" :showspecialist="true" :isHideMenu="true"></tedftNavigation>


    </b-col>

</b-row>
</template>
<script>
    /* eslint-disable */
    import { mapGetters } from 'vuex';
    import tedtfHeader from '../components/tedtfHeader.vue';

    import tedftNavigation from '../components/tedftNavigation.vue';
    
  import { required, email, maxLength, alpha } from "vuelidate/lib/validators";
   import modalImpDisc from '@/components/modalImpDisc.vue';
  import axios from 'axios';
    export default {
        name: "email",
        mounted: function() {},
        components: {
            'tedtfHeader': tedtfHeader,
            'tedftNavigation': tedftNavigation,
     'modalImpDisc': modalImpDisc
        },

        computed: {
            ...mapGetters('userData', ['userData'])
        },

 validations: {
      userData: {
        email: {
          required,
          email,
          maxLength: maxLength(100)
        },
      }
    },
        methods: {
        
        showModal() {
          this.userData.isEmailSent = true;
        },    
            
        submit: function() {
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid) {
          //   this.scrollToError();
            return false;
          }
        },
        
        handleSubmit(e, email, name) {
          this.submitted = true;
          this.$v.$touch();
          if (this.$v.$invalid) {
          //   this.scrollToError();
            return false;
          }
          else {
            
            const config = this.$config.config;
            const serviceUrl = config.serviceUrl;
            console.log(config,serviceUrl);
            axios({
                method: 'post',
                url: `${serviceUrl}/mail/v1/share`,
                data: {
                  appId: config.apiKey,
                  name: name,
                  to: email,
                },
                headers: { 'X-App-ID': config.apiKey }
              })
              .then(response => {
                console.log("in response: ", response)
                this.showModal();
                var obj={ 
                  hitType: 'event',
                  eventCategory: 'TED Symptoms Link Share',
                  eventAction: "TED Symptoms Link Share Via Email",
                };
                try {
                  console.log("sending Message:", JSON.stringify(obj));
                  window.top.postMessage(JSON.stringify(obj), "*");
                } catch(e) {
                  console.log("error sending Message");
                }
              })
              .catch(e => {
                // TODO display error on page.
                console.log(e);
              })
          }
        },
      },

        data() {
            return {
              placeholderEmail: "[Enter Destination Email]",
              submitted: false,
            };
        },
    };
</script>


<style lang="scss" scoped>
</style>
